/**
 * Foundation Context - axios interceptor.
 *
 * Aggiunge automaticamente header `X-Suite-Context-*` a ogni richiesta,
 * cosi' che i moduli della Suite (Presenze, Studio, Finance, ...) possano
 * ricevere il contesto operativo corrente senza doverlo passare a mano.
 *
 * Gli header sono strettamente INFORMATIVI: il backend Context Engine
 * puo' consumarli via middleware, ma la Source of Truth resta la tabella
 * `context_state` server-side. Nessuna escalation di privilegi e' possibile
 * modificando gli header lato client.
 */
let _ctx = null;

export function setInterceptorContext(ctx) {
  _ctx = ctx;
}

export function attachContextInterceptor(api) {
  api.interceptors.request.use((cfg) => {
    if (!_ctx) return cfg;
    try {
      cfg.headers = cfg.headers || {};
      if (_ctx.tenant?.id) cfg.headers["X-Suite-Context-Tenant"] = _ctx.tenant.id;
      if (_ctx.company?.id) cfg.headers["X-Suite-Context-Company"] = _ctx.company.id;
      if (_ctx.module?.app_key) cfg.headers["X-Suite-Context-Module"] = _ctx.module.app_key;
      if (_ctx.role?.code) cfg.headers["X-Suite-Context-Role"] = _ctx.role.code;
      if (_ctx.is_impersonating && _ctx.effective_user?.id) {
        cfg.headers["X-Suite-Context-Impersonating"] = _ctx.effective_user.id;
      }
    } catch { /* fail-safe: mai bloccare la richiesta */ }
    return cfg;
  });
}
